import React from 'react';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import styles from './answerKeys.scss';
import SectionAnswerKeys from './SectionAnswerKeys';

const AnswerKeys = () => {
    return (<div className={styles.answerKeysWrapper}>
        <table className={styles.answerKeys}>
            <tbody>
                {assessmentReader.getSections().map(section => (
                    <SectionAnswerKeys key={section.id} section={section} />
                ))}
            </tbody>
        </table>
    </div>);
};

export default AnswerKeys;
